import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import TextField from '../TextField';

// Component
export interface IProps {
  label?: string;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  fieldState: FieldState<string>;
  type?: string;
  margin?: 'normal';
  fullWidth?: boolean;
  multiline?: boolean;
  rows?: number;
  autoFocus?: boolean;
  style?: React.CSSProperties;
  errorText?: string | null;
}

function FormStateTextField(props: IProps) {
  const { fieldState, helperText, errorText, ...rest } = props;
  return (
    <TextField
      {...rest}
      value={fieldState.value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        fieldState.onChange(e.target.value)
      }
      error={fieldState.hasError || !!errorText}
      helperText={fieldState.error || errorText || helperText}
      onBlur={
        fieldState.dirty
          ? fieldState.enableAutoValidationAndValidate
          : undefined
      }
    />
  );
}

export default observer(FormStateTextField);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStateFields/TextField.tsx